module.exports = __webpack_public_path__ + "img/Unidad10-6.463abcd0.png";